import { render, staticRenderFns } from "./BrandHealthSimpleData.vue?vue&type=template&id=617e0f23&scoped=true&"
import script from "./BrandHealthSimpleData.vue?vue&type=script&lang=js&"
export * from "./BrandHealthSimpleData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e0f23",
  null
  
)

export default component.exports